import { Plus, Info } from "lucide-react";
import { Button } from "../ui/button";
import { CausesList } from "./CausesList";
import { CauseEditForm } from "./CauseEditForm";
import { useCausesManager, type CauseItem } from "./useCausesManager";

interface AdminCausesTabProps {
  causes: CauseItem[];
  onRefresh: () => void;
}

export function AdminCausesTab({ causes, onRefresh }: AdminCausesTabProps) {
  const {
    editingCause,
    setEditingCause,
    activeDraft,
    startAdd,
    handleEdit,
    handleSaveDraft,
    handleDiscardDraft,
    handleSave,
    handleDelete,
    handleMove,
  } = useCausesManager(causes, onRefresh);

  const sortedCauses = [...causes].sort((a, b) => a.sort_order - b.sort_order);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center pb-2 border-b border-border/80 text-left">
        <div>
          <h4 className="text-xl font-bold text-foreground uppercase tracking-wider">
            Community Values & Causes
          </h4>
          <p className="text-xs text-muted-foreground mt-0.5">
            Manage the values cards displayed on the community page
          </p>
        </div>
        {!editingCause && (
          <Button onClick={startAdd} className="bg-brand-primary text-white">
            <Plus className="h-4 w-4 mr-2" /> Add Value Card
          </Button>
        )}
      </div>

      <div className="flex items-start gap-2.5 p-3 rounded-xl bg-brand-primary/5 dark:bg-brand-primary/10 border border-brand-primary/10 text-brand-primary text-xs max-w-3xl leading-relaxed text-left">
        <Info className="h-4 w-4 shrink-0 mt-0.5" />
        <div>
          <strong>Causes Limit:</strong> A maximum of <strong>4 items</strong> will be displayed in
          the community values grid on the public site.
        </div>
      </div>

      {editingCause ? (
        <CauseEditForm
          editingCause={editingCause}
          setEditingCause={setEditingCause}
          onSave={handleSave}
          onCancel={() => {
            setEditingCause(null);
          }}
          activeDraft={activeDraft}
          onSaveDraft={handleSaveDraft}
          onDiscardDraft={handleDiscardDraft}
          liveCause={causes.find((c) => c.id === editingCause.id)}
        />
      ) : (
        <CausesList
          causes={sortedCauses}
          onMove={handleMove}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      )}
    </div>
  );
}

export default AdminCausesTab;
